module.exports = __webpack_public_path__ + "img/editor.19fff0c.jpg";